<template>
  <main class="main">
    <button @click="backStep" class="button button-back"><span>Back</span></button>

    <img :src="finalImage" id="embedImage">

    <div class="ios-submit" v-if="$store.state.iOS && $store.state.mobileDevice">
      <p><strong>Tap and hold</strong> the image above to 'Save Image' to your camera roll, then submit.</p>

      <div class="change-wrapper">
        <button class="button submit" @click="iOSsubmit">SUBMIT PHOTO</button>
      </div>

      <div class="fixed-popup" :class="{ active: isActive }">
        <div class="alert">
          <p><strong>Have you saved your image yet?</strong> <br/>If not, go back and save it before continuing.</p>
          <div class="change-wrapper">
            <button class="button submit finalSubmit" @click="iOSsubmitForReal">Submit Photo</button>
            <button class="button grey" @click="closePopup">GO BACK & SAVE</button>
          </div>
        </div>
      </div>
    </div>

    <div class="normal-submit" v-else>
      <div class="change-wrapper">
        <p v-if="error">{{ error }}</p>
        <button class="button submit finalSubmit" @click="submit">Submit Photo</button>
      </div>
    </div>

    <div class="vehicle">
      <img src="../assets/jeep-vehicle.png" alt="Jeep vehicle">
    </div>
  </main>
</template>

<script>
export default {
  name: 'submit',
  data () {
    return {
      finalImage: this.$store.state.payload.finished_image,
      finalPayload: {
        photo: this.$store.state.payload.finished_image,
        mood: this.$store.state.payload.mood
      },
      error: null,
      isActive: false
    }
  },
  mounted () {
    this.$store.state.isLoading = false
  },
  methods: {
    backStep () {
      this.$router.push({ path: '/grill' })
    },
    submit () {
      // let url = this.finalImage.replace('data:image/png;base64,', '')
      const link = document.createElement('a')
      link.href = this.finalImage
      link.setAttribute('download', 'jeepcomp.jpg')
      document.body.appendChild(link)
      link.click()
      this.$store.state.isLoading = true
      setTimeout(() => {
        this.submitAxios()
      }, 200)
    },
    iOSsubmit () {
      this.isActive = true
    },
    iOSsubmitForReal () {
      this.submitAxios()
    },
    closePopup () {
      this.isActive = false
    },
    submitAxios () {
      console.log(this.finalPayload)
      this.$http.submitPhoto(this.finalPayload)
        .then((res) => {
          console.log('then submit', res)
          if (res.status !== undefined) {
            this.$router.push({ path: '/confirm' })
          } else {
            console.log('inside error', res.response.data.errors)
            this.error = res.response.data.errors
          }
        })
        .then((res) => {
          this.$store.state.isLoading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../scss/variables.scss";
  .main {
    position: relative;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    text-align: center;
  }

  img {
    width: 100%;
    max-width: 500px;
    margin: 0 auto 20px;
  }

  .ios-submit {
    display: inline-block;
    width: 80%;
    margin: auto;

    p {
      font-size: 16px;
      font-weight: 600;
      color: white;
      strong {
        color: $color-1;
      }
    }
  }

  .change-wrapper {
    display: inline-block;
    width: 100%;
    padding: 0 6%;

    p {
      display: inline-block;
      font-weight: 600;
      line-height: 46px;
      color: white;
    }

    .button.submit {
      width: 100%;
      margin: 0 0 10px;
    }
  }

  .carousel-wrapper {
    display: inline-block;
    width: 100%;
  }

  .fixed-popup {
    .alert {
      p {
        color: #333;
      }
    }
  }

  .vehicle {
    position: relative;
    width: 100%;
    padding: 10px 0 0 0;
    margin: auto;

    img {
      position: relative;
      z-index: 1;
      width: 140px;
      margin: 0 auto 20px;
    }
  }

</style>
